<template>
    <notifications group="user-notif" :position="position" width="350" :max="5">
        <template slot="body" slot-scope="props" >
            <div class="notif-con">
                <a :href="props.item.url" class="wrapper">
                    <div class="notif-close">
                        <svg v-if="hasClose" @click.prevent.stop="props.close" class="t-icon times" width="18" height="18"></svg>
                    </div>  
                    <div class="img-wrap" v-if="props.item.data.customer_support">
                        <img :src="props.item.data.image" class="img-responsive">
                    </div>
                    <div v-else-if="props.item.data.image" class="img-wrap" @click="$router.push({ name: 'user-other-profile', params: { name: props.item.data.nick_name } })">
                        <img :src="props.item.data.image" class="img-responsive">
                        <i v-if="props.item.data.type" :class="`icon icon-notif-${props.item.data.type}`"></i>
                    </div>
                    <div class="detail-wrap">
                        <span class="title">{{ props.item.title }}</span>
                        <span class="content">{{ contentLimit(props.item.text) }}</span>
                        <router-link class="notif-link" :to="notifUrl(props.item.data)" v-if="!props.item.data.customer_support">{{ notifUrl(props.item.data, true) | translate }}</router-link>
                    </div>
                    <div class="action-wrap">
                        <i :class="`icon icon-notif-bell${!notif_sound ? '-disabled' : ''}`" @click="toggleNotifSound()"></i>
                        <i class="icon icon-notif-close" @click="props.close"></i>
                    </div>
                </a>
            </div>
        </template>
    </notifications>
</template>

<script>
    import UserNotif from '@views/common/UserNotif/user_notif'

    export default {
        mixins: [UserNotif]
    }
</script>

<style lang="scss">
    .notif-close {
        position: absolute;
        right: 10px;
        top: 12px;
        height: 14px;
    }
</style>

